import { useZendeskChat } from '~/composables/useZendeskChat'

const NON_DIGIT_RE = /\D/g

function normalizeContactValue(value) {
  return value?.trim() || ''
}

function toWhatsAppHref(phone) {
  const digits = normalizeContactValue(phone).replace(NON_DIGIT_RE, '')
  return digits ? `https://wa.me/${digits}` : null
}

export function useContactOptions() {
  const { t } = useI18n()
  const authStore = useAuthStore()
  const { settings } = storeToRefs(authStore)
  const { isChatAvailable } = useZendeskChat()

  const contactOptions = computed(() => {
    const options = []

    const phone = normalizeContactValue(settings.value?.help_phone)
    if (phone) {
      options.push({
        icon: 'phone',
        value: phone,
        label: t('contact.popover.phone'),
        href: `tel:${phone}`,
      })
    }

    const whatsapp = normalizeContactValue(settings.value?.help_whatsapp)
    const whatsappHref = toWhatsAppHref(whatsapp)
    if (whatsapp && whatsappHref) {
      options.push({
        icon: 'whatsapp',
        value: whatsapp,
        label: t('contact.popover.whatsapp'),
        href: whatsappHref,
        target: '_blank',
        rel: 'noopener noreferrer',
      })
    }

    const email = normalizeContactValue(settings.value?.help_email)
    if (email) {
      options.push({
        icon: 'mail',
        value: email,
        label: t('contact.popover.email'),
        href: `mailto:${email}`,
      })
    }

    if (isChatAvailable.value) {
      options.push({
        icon: 'chat',
        value: t('contact.popover.chatSupport'),
        label: t('contact.popover.chat'),
        action: 'chat',
      })
    }

    return options
  })

  return { contactOptions }
}
